module.exports = "<div>\n  <router-view></router-view>\n  <router-view name=\"childHeader\"></router-view>\n  <router-view name=\"content\"></router-view>\n  <router-view name=\"footerLeft\"></router-view>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/containers/block/block-apartments/template.html
// module id = s885
// module chunks = 0